import { Link } from 'react-router-dom'
import './HomePage.css'

const PeakIcon = () => (
  <svg className="feature-card-icon" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="4" y1="30" x2="32" y2="30" stroke="#0ea5e9" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
    <path d="M6,30 C6,30 12,30 13,26 C14,22 15,12 18,2 C21,12 22,22 23,26 C24,30 30,30 30,30" fill="none" stroke="#0ea5e9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="18" cy="2" r="2" fill="#0ea5e9"/>
  </svg>
)

function HomePage() {
  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <p className="hero-tagline">Precision Analysis, Definitive Results</p>
          <p className="hero-description">
            At <strong>Hilton Analytica</strong>, we deliver{' '}
            <strong>industry-leading purity analysis</strong> for{' '}
            <strong>research-use-only peptides</strong> with{' '}
            <strong>exceptional speed and accuracy</strong>. Our{' '}
            <strong>rigorous methodology</strong> combines advanced instrumentation with
            expert review, giving you results you can rely on — every time.
          </p>
          <div className="hero-actions">
            <Link to="/search" className="btn btn-primary">COA LOOKUP</Link>
            <Link to="/request" className="btn btn-secondary">Submit Samples for Testing</Link>
          </div>
        </div>
      </section>

      <section className="value-section">
        <div className="value-content">
          <h2>Rigorous science.<br />Uncompromising transparency.<br />The reference lab for peptide analysis.</h2>
          <p>
            Since 2023, Hilton Analytica has established the largest publicly
            searchable COA database in peptide testing. Every result is independently
            verified, every batch traceable, and every report delivered faster than
            the industry standard. No vendor ties. No conflicts. Just reliable science.
          </p>
        </div>
      </section>

      <section className="features-section">
        <div className="features-grid">
          <div className="feature-card">
            <PeakIcon />
            <h3>Industry-leading turnaround</h3>
            <p>Results delivered in 5-10 days — faster than any competing lab.</p>
          </div>
          <div className="feature-card">
            <PeakIcon />
            <h3>Fully transparent</h3>
            <p>Every COA is publicly searchable by accession number or company name. Your clients can verify any batch independently.</p>
          </div>
          <div className="feature-card">
            <PeakIcon />
            <h3>Dual-method verification</h3>
            <p>HPLC confirms purity. LC-MS confirms identity. We never issue one without the other — an incomplete answer serves no one.</p>
          </div>
          <div className="feature-card">
            <PeakIcon />
            <h3>Completely independent</h3>
            <p>No vendor affiliations. No supplier relationships. No conflicts of interest. We test for the research community.</p>
          </div>
          <div className="feature-card">
            <PeakIcon />
            <h3>Serving vendors worldwide</h3>
            <p>From the UK to the U.S. and beyond, vendors ship samples to Hilton Analytica and get results back faster than any other lab.</p>
          </div>
          <div className="feature-card">
            <PeakIcon />
            <h3>Trusted by the community</h3>
            <p>Recommended by vendors, cited in group buys, and reviewed publicly by researchers. Our reputation was built sample by sample since 2023.</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Get Started?</h2>
        <p>Look up your Certificate of Analysis or contact us to learn more about our analysis services.</p>
        <div className="hero-actions">
          <Link to="/search" className="btn btn-primary">COA LOOKUP</Link>
          <Link to="/contact" className="btn btn-secondary">CONTACT US</Link>
        </div>
      </section>
    </div>
  )
}

export default HomePage
